import React, { useMemo } from "react";
import PlayerLeagueBets from "./PlayerLeagueBets";
import { groupLeagueBetsByLeague } from "../../helpers/betsNormalization";

const GroupLeagueBets = ({
	currentUniqueIdentifierSelected,
	leagueBets = [],
}) => {
	const dataGroupedByLeague = useMemo(
		() =>
			groupLeagueBetsByLeague(
				leagueBets,
				currentUniqueIdentifierSelected
			),
		[leagueBets, currentUniqueIdentifierSelected]
	);

	return (
		<div className='card-body'>
			<div className='container'>
				{Object.keys(dataGroupedByLeague).map((leagueId) => {
					const data = dataGroupedByLeague[leagueId];
					return (
						<PlayerLeagueBets
							key={leagueId}
							playerLeagueBets={data.items}
						></PlayerLeagueBets>
					);
				})}
			</div>
		</div>
	);
};

export default GroupLeagueBets;
